import { CONSTANTS } from 'client/utils/constants';
import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import TransferApprovalApiService from './TransferApprovalApiService';
import {setTransferOrderById} from 'Store/Transfer/Transfer/TransferOrderByIdAction'
import TransferAction from 'Store/Component/Transfer/TransferAction';
import { GET_TRANSFER_ORDER_BY_ID, CREATE_TRANSFER_ORDER_REQUEST } from 'Store/Transfer/Transfer/TransferOrderByIdType';
import { apiMethod, apiType, API_URL } from 'utils';
import { IPayload } from 'Model/IPayload';
import { setPenaltyGlobalFlag } from 'Store/OrderManagement/DispositionPenaltyFee/DispositionPenaltyFeeAction';
import { GET_AFE_ORDER_BY_ID, GET_LEADR_ORDER_VALIDATION, GET_SAVE_AFE_RECLASSIFICATION, GET_VALIDATE_AFE_ASSET_NUMBER, GET_VALIDATE_ASSETS_ON_SAVE } from 'Store/Component/Transfer/TransferType';
import api from "../../client/utils/clientApiHelper";

function* getTransferOrderById(req: any): any {
    let orderId = req.val
    let payloadData : IPayload = {                
        apiMethod : apiMethod.GET,
        apiType : apiType.OrderManagement,
        endpoint : `orders/asset/${orderId}`,  
        payload : null      
    }
    try {
        yield put(globalLoaderText("Fetching Asset Order Details...."));

        const response = yield call(
            TransferApprovalApiService.post,
            API_URL.PostWebApp, payloadData
        );
        if(response){
            // console.log(response,"AssetOrderRequestby id - Submit")
        yield put(setTransferOrderById(response))
        yield put(setPenaltyGlobalFlag(response?.dispositionPenaltyFlag))    
        yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(setTransferOrderById([]))
        yield put(globalLoaderText(""));
    }
}

function* createTransferRequest(transferOrderRequest: any): any {
    // console.log(transferOrderRequest,"AssetOrderRequest - Submit")
    try {
        let orderRequestType="";
        if(transferOrderRequest?.transferOrderRequest?.orderTypeId == 4)
        {
            orderRequestType= CONSTANTS.TRANSFER
        }
        else if(transferOrderRequest?.transferOrderRequest?.orderTypeId == 5)
        {
            orderRequestType= CONSTANTS.DISPOSITION
        }else if(transferOrderRequest?.transferOrderRequest?.orderTypeId == 6)
        {
            orderRequestType= CONSTANTS.REACTIVATION
        }
        if (transferOrderRequest?.transferOrderRequest?.orderAction == CONSTANTS.ORDER_SAVE) {
            yield put(globalLoaderText("Saving "+orderRequestType+" Order ...."));
        } else if (transferOrderRequest?.transferOrderRequest?.orderAction == CONSTANTS.ORDER_SUBMIT) {
            yield put(globalLoaderText("Creating "+orderRequestType+" Order ...."));
        }

        let payloadData : IPayload = {                
            apiMethod : apiMethod.POST,
            apiType : apiType.OrderManagement,
            endpoint : `orders/asset`,
            payload : transferOrderRequest.transferOrderRequest
        }

        const response = yield call(
            TransferApprovalApiService.post,            
            API_URL.PostWebApp, payloadData
        );

        if (response?.orderId == null) {
            yield put(globalLoaderText(""));
            yield put(TransferAction.setOrderCreationSuccess(response))
        }
        else {
            yield put(TransferAction.setOrderCreationSuccess(response))
            yield put(TransferAction.setTransferOrderNumber(response?.orderId));
            yield put(globalLoaderText(""));
        }

    } catch (error) {
        console.log(error);
        yield put(TransferAction.setOrderCreationSuccess({
            orderId: null,
            errorMessage: ""
        }))
        yield put(globalLoaderText(""));
    }
}

function* getLeaderOrderValidation(req: any): any {
    let orderId = req.orderNumber   
    let payloadData : IPayload = {                
        apiMethod : apiMethod.POST,
        apiType : apiType.OrderManagement,
        endpoint : `orders/validateExistingOrderRequestId?existingOrderRequestId=${orderId}`,  
        payload : null      
    }
    try {
        yield put(globalLoaderText("Validating Order Id...."));

        const response = yield call(
            TransferApprovalApiService.post,
            API_URL.PostWebApp, payloadData
        );
            yield put(TransferAction.setLeadOrderValidation(response))   
            yield put(globalLoaderText(""));
    }
    catch (error) {
        yield put(TransferAction.setLeadOrderValidation('error'))  
        yield put(globalLoaderText(""));
    }
}

function* getAFEAssetValidation(req: any): any {
    console.log(req.val,"req.val")
    try {
      yield put(globalLoaderText("Validating Asset details...."));
      let payloadData : IPayload = {
        apiType : apiType.AssetManagement,
        endpoint : `assets/validate`,
        apiMethod :  apiMethod.POST,
        payload : req.val
       }
      const response = yield call(
        api.callAssetPost, API_URL.PostWebApp, payloadData      
        );
        yield put(globalLoaderText(""));
        yield put(TransferAction.setAFEAssetValidation({...response, assetNumber: req.val.assetNumber}));
    } catch (error: any) {
      yield put(globalLoaderText(""));
      yield put(TransferAction.setAFEAssetValidation({validationMessage: "Please enter valid Asset #", isValid: false, assetNumber: req.val.assetNumber}))
    }
  }

  function* getSaveAfeReClassification(req: any): any {
    console.log(req.val,"req.val")
    try {
      yield put(globalLoaderText(`${req.val.orderAction == 'Submit' ? 'Submitting' : 'Saving'} the request....`));
      let payloadData : IPayload = {
        apiType : apiType.OrderManagement,
        endpoint : `orders/afe`,
        apiMethod :  apiMethod.POST,
        payload : req.val
       }
      const response = yield call(
        api.callAssetPost, API_URL.PostWebApp, payloadData      
        );
        yield put(globalLoaderText(""));
        yield put(TransferAction.setSaveAfeReClassification(response));
    } catch (error: any) {
      yield put(globalLoaderText(""));
      yield put(TransferAction.setSaveAfeReClassification({
        orderId: null,
        errorMessage: `Error occured while ${req.val.orderAction == 'Submit' ? 'Submitting' : 'Saving'} the request`
      }))
    }
  }

  function* getAfeOrderById(req: any): any {
    console.log(req.val,"req.val")
    try {
      yield put(globalLoaderText(`Getting the AFE Request order....`));
      let payloadData : IPayload = {
        apiType : apiType.OrderManagement,
        endpoint : `orders/afe/${req.val}`,
        apiMethod :  apiMethod.GET,
        payload : null
       }
      const response = yield call(
        api.callAssetPost, API_URL.PostWebApp, payloadData      
        );
        yield put(globalLoaderText(""));
        yield put(TransferAction.setAfeOrderByIdData(response));
    } catch (error: any) {
      yield put(globalLoaderText(""));
      yield put(TransferAction.setAfeOrderByIdData("Error occured while fetching the AFE Request order"))
    }
  }

function* validateAssetsOnSave(req: any): any {
    try {
        yield put(globalLoaderText("Validating assets...."));
        let payloadData: IPayload = {
            apiType: apiType.OrderManagement,
            endpoint: `orders/asset/validate/onSave`,
            apiMethod: apiMethod.POST,
            payload: req.val
        }
        const response = yield call(
            TransferApprovalApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(globalLoaderText(""));
        yield put(TransferAction.setValidateAssetsOnSave(response));
    } catch (error: any) {
        yield put(globalLoaderText(""));
        yield put(TransferAction.setValidateAssetsOnSave(null));
    }
}

function* watchTransferOrder() {
    yield takeEvery(GET_TRANSFER_ORDER_BY_ID, getTransferOrderById);
    yield takeEvery(CREATE_TRANSFER_ORDER_REQUEST, createTransferRequest);
    yield takeEvery(GET_LEADR_ORDER_VALIDATION, getLeaderOrderValidation);
    yield takeEvery(GET_VALIDATE_AFE_ASSET_NUMBER, getAFEAssetValidation);
    yield takeEvery(GET_SAVE_AFE_RECLASSIFICATION, getSaveAfeReClassification);
    yield takeEvery(GET_AFE_ORDER_BY_ID, getAfeOrderById);
    yield takeEvery(GET_VALIDATE_ASSETS_ON_SAVE, validateAssetsOnSave);
}

export default function* combinedSaga() {
    yield all([
        watchTransferOrder()
    ])
}
